import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';
import { LoadingCircle } from './LoadingCircle';

export const StyledLoadingIndicatorWrapper = styled.div<{ isLoading: boolean }>(
	undefined,
	ifProp('isLoading', () => ({
		position: 'relative',
		overflow: 'hidden',
	})),
);

const StyledLoadingCircle = styled(LoadingCircle)(({ theme }) => ({
	position: 'absolute',
	top: '0',
	left: '0',
	height: '100%',
	width: '100%',
	zIndex: theme.zIndices.contentLoadingOverlay + 1,
}));

const StyledOverlay = styled.div(({ theme }) => ({
	position: 'absolute',
	top: 0,
	width: '100%',
	height: '100%',
	backgroundColor: theme.colors.loadingOverlay,
	zIndex: theme.zIndices.contentLoadingOverlay,
}));

export const LoadingOverlay = ({ isLoading, children, includeLoadingCircle }: { isLoading: boolean; children: React.ReactNode; includeLoadingCircle?: boolean }) => {
	return (
		<StyledLoadingIndicatorWrapper isLoading={isLoading}>
			{children}
			{isLoading && <StyledOverlay />}
			{isLoading && includeLoadingCircle && <StyledLoadingCircle size="md" />}
		</StyledLoadingIndicatorWrapper>
	);
};
